<script>
import { mapState, mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("sidebar", ["setOpened"]),
    ...mapActions("user", ["clearToken"]),
    isMobile() {
      return Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      ) <= 960
        ? true
        : false;
    },
    logout() {
      this.clearToken();
      this.$router.push("/login");
    }
  },

  computed: {
    ...mapState("sidebar", ["opened", "route"]),
    ...mapState("user", ["user"])
  },

  mounted() {
    this.setOpened(!this.isMobile());
  }
};
</script>

<template>
  <div>
    <nav :class="{ opened: opened }">
      <div class="header">
        <img src="/static/logo-branco.svg" />
      </div>

      <div class="user">
        <img v-if="user.profile" :src="user.profile.profile_picture" alt />
        <div class="text">
          <div>Bem-vindo(a),</div>
          <div>
            {{ user.first_name }}
            <div class="dropdown">
              <img src="/static/arrow-down.svg" height="10px" alt="Opções" />

              <div class="dropdown-content">
                <ul>
                  <li><img src="/static/profile-outline.svg" /> perfil</li>
                  <li @click="logout"><img src="/static/logout.svg" /> sair</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <ul>
        <li :class="{ active: ['dashboard'].indexOf(route) != -1 }">
          <router-link to="/dashboard">
            <img src="/static/menu-dashboard.svg" /> DASHBOARD
          </router-link>
        </li>

        <li :class="{ active: ['notifications'].indexOf(route) != -1 }">
          <router-link to="/notificacoes">
            <img src="/static/menu-notifications.svg" /> NOTIFICAÇÕES
          </router-link>
        </li>
      </ul>

      <span>USUÁRIOS</span>
      <ul>
        <li :class="{ active: ['donamakers'].indexOf(route) != -1 }">
          <router-link to="/donamakers">
            <img src="/static/menu-donamakers.svg" /> DONAMAKERS
          </router-link>
        </li>

        <li :class="{ active: ['clients'].indexOf(route) != -1 }">
          <router-link to="/clientes">
            <img src="/static/menu-clients.svg" /> CLIENTES
          </router-link>
        </li>

        <li
          :class="{
            active: ['professionals', 'professionals-edit'].indexOf(route) != -1
          }"
        >
          <router-link to="/profissionais">
            <img src="/static/menu-professionals.svg" /> PROFISSIONAIS
          </router-link>
        </li>
      </ul>

      <span>CONTROLE</span>
      <ul>
        <li :class="{ active: ['orders'].indexOf(route) != -1 }">
          <router-link to="/pedidos">
            <img src="/static/menu-orders.svg" /> PEDIDOS
          </router-link>
        </li>

        <li
          class="inactive"
          :class="{ active: ['subscription'].indexOf(route) != -1 }"
        >
          <a> <img src="/static/menu-subscriptions.svg" /> ASSINATURAS </a>
        </li>

        <li :class="{ active: ['cities'].indexOf(route) != -1 }">
          <router-link to="/cidades">
            <img src="/static/menu-cities.svg" /> CIDADES
          </router-link>
        </li>

        <li
          class="inactive"
          :class="{ active: ['wallet-of-company'].indexOf(route) != -1 }"
        >
          <a>
            <img src="/static/menu-wallet-of-company.svg" /> CARTEIRA DA EMPRESA
          </a>
        </li>

        <li :class="{ active: ['transfers'].indexOf(route) != -1 }">
          <router-link to="/transferencias">
            <a> <img src="/static/menu-transfers.svg" /> TRANSFERÊNCIAS </a>
          </router-link>
        </li>

        <li :class="{ active: ['coupons'].indexOf(route) != -1 }">
          <router-link to="/cupons">
            <img src="/static/menu-coupons.svg" /> CUPONS
          </router-link>
        </li>

        <li
          :class="{
            active: ['professional-register-flow'].indexOf(route) != -1
          }"
        >
          <router-link to="/cadastro-profissionais">
            <img src="/static/menu-professional-register-flow.svg" /> CADASTRO
            DE PROFISSINAIS
          </router-link>
        </li>

        <li
          :class="{
            active: ['professional-training-flow'].indexOf(route) != -1
          }"
        >
          <router-link to="/treinamento-profissionais">
            <img src="/static/menu-training.svg" />
            TREINAMENTO PROFISSINAIS
          </router-link>
        </li>
      </ul>
    </nav>

    <div class="backdrop" @click="setOpened(!opened)"></div>
  </div>
</template>

<style scoped>
nav {
  color: #333 !important;
  background: #e2e2e2;
  min-height: 100vh;
  height: 100%;
  overflow-y: auto;
  width: 0;
  transition: all 0.24s ease;
}

nav.opened {
  width: 260px;
}

nav hr {
  margin: 10px 30px;
  border-top: 1px solid #c9c9c9;
  border-left: none;
  border-right: none;
  border-bottom: none;
}

nav .user {
  display: flex;
  flex-direction: row;
  justify-content: center;
  color: #333;
  margin: 10px 0;
}

nav .user img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  object-position: center;
  margin: 0 10px 0 0;
  border: 3px solid #fff;
  border-radius: 100%;
}

nav .user .text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

nav .user .text img {
  width: 10px;
  height: 10px;
  object-fit: contain;
  object-position: center;
  margin: 0 10px;
  border: none;
  cursor: pointer;
}

nav .user .text div:first-child {
  margin-bottom: 0;
}

nav .user .text div:last-child {
  margin-top: 5px;
  font-weight: bold;
  display: flex;
}

nav .header {
  background: var(--gradient);
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

nav .header img {
  width: calc(100% - 60px);
  object-fit: contain;
  object-position: center;
}

nav ul {
  margin-top: 5px;
  padding-left: 0;
}

nav ul li {
  list-style: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-left: 30px;
  border-left: 8px solid;
  border-color: transparent;
  transition: all 0.25s ease;
}

nav ul li.active {
  border-color: var(--purple);
  background-color: rgba(0, 0, 0, 0.03);
}

nav ul li.inactive {
  opacity: 0.3;
}

nav ul li:hover {
  padding-left: 40px;
}

nav ul li img {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

nav ul li a {
  color: #333 !important;
  font-size: 13px;
  font-weight: 400;
  line-height: 33.238px;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
}

nav span {
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  margin-left: 30px;
}

.backdrop {
  display: none;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(242, 242, 242, 0.8);
  cursor: pointer;
  z-index: 2;
}

@media (max-width: 960px) {
  nav {
    position: absolute;
    left: -260px;
    z-index: 3;
  }

  nav.opened {
    left: 0;
  }

  nav.opened ~ .backdrop {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue